module.exports = __webpack_public_path__ + "img/template.5407ef03.svg";